export const DROPDOWN = 'LISTEN_TO_KEYBOARD.DROPDOWN'
export const MODAL = 'LISTEN_TO_KEYBOARD.MODAL'
export const MODAL_DROPDOWN = 'LISTEN_TO_KEYBOARD.MODAL_DROPDOWN'
